<template>
    <div class="card mt-4 ubn-card">
      <ul class="nav flex-column bg-white border-radius-lg p-3">
        <li class="nav-item">
          <a class="nav-link text-dark d-flex" data-scroll href="#profile">
            <i class="material-symbols-rounded text-lg me-2">person</i>
            <span class="text-sm">{{ $t('user.Profile') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#user-info">
            <i class="material-symbols-rounded text-lg me-2">receipt_long</i>
            <span class="text-sm">{{ $t('user.User_info') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#address">
            <i class="material-symbols-rounded text-lg me-2">contacts</i>
            <span class="text-sm">{{ $t('user.Address') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#password">
            <i class="material-symbols-rounded text-lg me-2">lock</i>
            <span class="text-sm">{{ $t('user.Password') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#sessions">
            <i class="material-symbols-rounded text-lg me-2">settings_applications</i>
            <span class="text-sm">{{ $t('user.Sessions') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#profileimage">
            <i class="material-symbols-rounded text-lg me-2">image</i>
            <span class="text-sm">{{ $t('user.Profile_image') }}</span>
          </a>
        </li>
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#signatureimage">
            <i class="material-symbols-rounded text-lg me-2">image</i>
            <span class="text-sm">{{ $t('user.Signature_image') }}</span>
          </a>
        </li>  
        <li class="nav-item pt-2">
          <a class="nav-link text-dark d-flex" data-scroll href="#delete">
            <i class="material-symbols-rounded text-lg me-2">delete</i>
            <span class="text-sm">{{ $t('user.Delete_user') }}</span>
          </a>
        </li>
      </ul>
    </div>

    <div v-if="ubns && ubns.length" class="card mt-4 ubn-card">
      <ul class="nav flex-column bg-white border-radius-lg p-3">
        <li v-for="item in ubns" :key="item.id" class="nav-item mb-3">        
            <div class="d-flex align-items-start">
                <i class="material-symbols-rounded text-lg me-2">location_on</i>
                <div>
                    <div class="text-sm font-weight-bold">{{ item.ubn }}</div>
                    <div class="text-sm">{{ item.fullAddress }}</div>
                    <div class="text-sm"><b>{{ $t('location.Active_animals') }}:</b> {{ item.animalCount }}</div>
                    <div class="text-sm d-flex align-items-center">
                        <b class="me-1">{{ $t('location.RVO_Verified') }}:</b>
                        <i style="font-size: 12px;" class="material-symbols-rounded opacity-10 font-size-12" :class="item.isRvoVerified ? 'text-success' : 'text-danger'" aria-hidden="true">
                            {{ item.isRvoVerified ? 'thumb_up' : 'thumb_down' }}
                        </i>
                    </div>
                </div>
            </div>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "EditUserSideNav",

    props: {
        ubns: {
            type: Array,
            default: () => []
        }
    }
  };
  </script>
  <style scoped>
.ubn-card {
    margin-top: 16px !important;
}

.ubn-card ul {
    margin-bottom: 0;
}

.ubn-card .nav-item {
    padding: 0;
}

.ubn-content {
    min-width: 0;
}

.ubn-number {
    color: #6c757d;
    margin-bottom: 2px;
}

.ubn-address {
    color: #6c757d;
    margin-bottom: 2px;
}

.ubn-location-icon {
    color: #6c757d;
    font-size: 18px !important;
}

.ubn-rvo-icon {
    font-size: 14px !important;
    line-height: 1;
}
</style>
  